module.exports = __webpack_public_path__ + "static/img/PEC-Logo-1.27c2864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PEC-Logo-1.png
// module id = gh5k
// module chunks = 1